<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Bullet_Hole.html" xml:lang="en-US">
<div class="calibre1">
<p class="book-title">Bullet Hole</p>
<p class="book-subtitle" xml:lang="en-GB">An Alan Saxon Mystery</p>
<p class="book-author" xml:lang="en-GB">Keith Miles</p>
<p class="body-center"><a class="calibre2" href="http://www.edwardmarston.com/saxon.html" target="_blank"><span class="hyperlink" xml:lang="en-US">www.EdwardMarston.com/Saxon.html</span></a></p>
<p class="book-publisher" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="body-center"><img alt="PPPlogo.jpg" class="image1" src="OEBPS/images/PPPlogo_fmt.png"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bullet_Hole.vue?fce0bf8a